// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___Kqmm","input":"styles_input__1eZB1"};